import { CategoryInput } from 'common/form/input/_categoryInput'
import { useHistoryOrderFilterForm } from '../../../../hooks/useHistoryOrderFilterForm'

export const OrderSearch = () => {
  const {orderId} = useHistoryOrderFilterForm()
  return (
  <CategoryInput
    className={'order-filter-form__input-wide'}
    categoryList={[]}
    categoryValue={{name: 'Mã đơn hàng', value: ''}}
    categoryWidth={104}
    placeholder='Nhập mã đơn hàng'
    value={orderId?.value || ''}
    onChange={orderId.onChange}
    style={{ position: 'relative'}}
  />
  )
}
